//Effects
import { all, put, takeLatest } from "redux-saga/effects";
import { defaultApi } from "utils/axiosApi";

import {
  GET_DASHBOARD_JOB_INFO_CUSTOM,
  GET_DASHBOARD_JOB_INFO_CUSTOM_FAILURE,
  GET_DASHBOARD_JOB_INFO_CUSTOM_SUCCESS,
  GET_DASHBOARD_ATTENDANCE,
  GET_DASHBOARD_ATTENDANCE_FAILURE,
  GET_DASHBOARD_ATTENDANCE_SUCCESS,
  GET_DASHBOARD_PERFORMERS,
  GET_DASHBOARD_PERFORMERS_SUCCESS,
  GET_DASHBOARD_PERFORMERS_FAILURE,
  GET_DASHBOARD_REVENUE_INFO,
  GET_DASHBOARD_REVENUE_INFO_SUCCESS,
  GET_DASHBOARD_REVENUE_INFO_FAILURE,
  GET_DASHBOARD_COMPLETE_JOB_COMPARE,
  GET_DASHBOARD_COMPLETE_JOB_COMPARE_SUCCESS,
  GET_DASHBOARD_COMPLETE_JOB_COMPARE_FAILURE,
  GET_DASHBOARD_CUSTOMER,
  GET_DASHBOARD_CUSTOMER_SUCCESS,
  GET_DASHBOARD_CUSTOMER_FAILURE,
  GET_DASHBOARD_ESTIMATION,
  GET_DASHBOARD_ESTIMATION_SUCCESS,
  GET_DASHBOARD_ESTIMATION_FAILURE,
  GET_DASHBOARD_ORG_SALES,
  GET_DASHBOARD_ORG_SALES_SUCCESS,
  GET_DASHBOARD_ORG_SALES_FAILURE,
  GET_DASHBOARD_ORGANIZATION_JOBS,
  GET_DASHBOARD_ORGANIZATION_JOBS_SUCCESS,
  GET_DASHBOARD_ORGANIZATION_JOBS_FAILURE,
  GET_DASHBOARD_PROJECT_COUNT,
  GET_DASHBOARD_PROJECT_COUNT_SUCCESS,
  GET_DASHBOARD_PROJECT_COUNT_FAILURE,
  GET_DASHBOARD_OPERATION_TOP_SECTION,
  GET_DASHBOARD_OPERATION_TOP_SECTION_SUCCESS,
  GET_DASHBOARD_OPERATION_TOP_SECTION_FAILURE,
  GET_DASHBOARD_RECENT_COMPLETED_JOBS,
  GET_DASHBOARD_RECENT_COMPLETED_JOBS_SUCCESS,
  GET_DASHBOARD_RECENT_COMPLETED_JOBS_FAILURE,
  GET_DASHBOARD_TIMESHEET_COUNT,
  GET_DASHBOARD_TIMESHEET_COUNT_SUCCESS,
  GET_DASHBOARD_TIMESHEET_COUNT_FAILURE,
  GET_DASHBOARD_SERVICE_TOP_SECTION,
  GET_DASHBOARD_SERVICE_TOP_SECTION_SUCCESS,
  GET_DASHBOARD_SERVICE_TOP_SECTION_FAILURE,
} from "../../modules/constants";

// Custom day dashboard api calls
export function* dashboardJobInfoCustomRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/job-count?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_JOB_INFO_CUSTOM_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_JOB_INFO_CUSTOM_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardAttendanceRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/attendance-count?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_ATTENDANCE_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_ATTENDANCE_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardPerformersRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/top-performers?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_PERFORMERS_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_PERFORMERS_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardRevenueRequest({ payload }) {
  const { organization_id } = payload;
  try {
    const url = `${organization_id}/dashboard/revenue-graph`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_REVENUE_INFO_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_REVENUE_INFO_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardCompleteJobCompareRequest({ payload }) {
  const { organization_id } = payload;
  try {
    const url = `${organization_id}/dashboard/completed-jobs-graph/`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_COMPLETE_JOB_COMPARE_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_COMPLETE_JOB_COMPARE_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardCustomerRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/top-customers?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_CUSTOMER_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_CUSTOMER_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardEstimationRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/estimated-time/?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_ESTIMATION_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_ESTIMATION_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardOrganizationSalesRequest({ payload }) {
  const { organization_id } = payload;
  try {
    const url = `${organization_id}/dashboard/organization-sales`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_ORG_SALES_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_ORG_SALES_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardOrganizationJobsRequest({ payload }) {
  const { organization_id } = payload;
  try {
    const url = `${organization_id}/dashboard/organization-jobs/`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_ORGANIZATION_JOBS_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_ORGANIZATION_JOBS_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardProjectCountRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/project-count/?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_PROJECT_COUNT_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_PROJECT_COUNT_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardTimesheetCountRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/timesheet-count/?start_time=${start_time}&end_time=${end_time}`;
    let method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_TIMESHEET_COUNT_SUCCESS,
      payload: response.data, // Extract actual data from Axios response
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_TIMESHEET_COUNT_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardServiceTopSectionRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/dashboard-service-top-section/?start_time=${start_time}&end_time=${end_time}`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_SERVICE_TOP_SECTION_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_SERVICE_TOP_SECTION_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardOperationTopSectionRequest({ payload }) {
  const { organization_id, start_time, end_time } = payload;
  try {
    const url = `${organization_id}/dashboard/dashboard-operation-top-section/?start_time=${start_time}&end_time=${end_time}`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_OPERATION_TOP_SECTION_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_OPERATION_TOP_SECTION_FAILURE,
      payload: err,
    });
  }
}

export function* dashboardRecentCompletedJobsRequest({ payload }) {
  const { organization_id } = payload;
  try {
    const url = `${organization_id}/dashboard/recent-completed-jobs/`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_DASHBOARD_RECENT_COMPLETED_JOBS_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: GET_DASHBOARD_RECENT_COMPLETED_JOBS_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(GET_DASHBOARD_JOB_INFO_CUSTOM, dashboardJobInfoCustomRequest),
    takeLatest(GET_DASHBOARD_ATTENDANCE, dashboardAttendanceRequest),
    takeLatest(GET_DASHBOARD_PERFORMERS, dashboardPerformersRequest),
    takeLatest(GET_DASHBOARD_REVENUE_INFO, dashboardRevenueRequest),
    takeLatest(GET_DASHBOARD_COMPLETE_JOB_COMPARE, dashboardCompleteJobCompareRequest),
    takeLatest(GET_DASHBOARD_CUSTOMER, dashboardCustomerRequest),
    takeLatest(GET_DASHBOARD_ESTIMATION, dashboardEstimationRequest),
    takeLatest(GET_DASHBOARD_ORG_SALES, dashboardOrganizationSalesRequest),
    takeLatest(GET_DASHBOARD_ORGANIZATION_JOBS, dashboardOrganizationJobsRequest),
    takeLatest(GET_DASHBOARD_PROJECT_COUNT, dashboardProjectCountRequest),
    takeLatest(GET_DASHBOARD_OPERATION_TOP_SECTION, dashboardOperationTopSectionRequest),
    takeLatest(GET_DASHBOARD_RECENT_COMPLETED_JOBS, dashboardRecentCompletedJobsRequest),
    takeLatest(GET_DASHBOARD_TIMESHEET_COUNT, dashboardTimesheetCountRequest),
    takeLatest(GET_DASHBOARD_SERVICE_TOP_SECTION, dashboardServiceTopSectionRequest),
  ]);
}
